import { makeAutoObservable } from 'mobx';
import { BookingDataType,DateTimeType,FormType,dropDowntype } from 'utils/type'; // Adjust the path as per your project structure

class Store {
  data: BookingDataType | any = null; // Single object, not an array
  selectedDateTime: DateTimeType | null = null; // Single object to store the latest selected date-time
  patientData:any| null=null
  APTDetails:any| null=null
  FormFields:FormType | any | null=null
  searchDropDown:dropDowntype | any

  constructor() {
    makeAutoObservable(this);
  }

  setData(data: BookingDataType | any) { // Accept single object, not an array
    this.data = data;
  }

  getData(): BookingDataType | any {
    return this.data;
  }

  setSelectedDateTime(dateTime: DateTimeType) {
    this.selectedDateTime = dateTime;
  }

  getSelectedDateTime(): DateTimeType | any {
    return this.selectedDateTime;
  }

  clearSelectedDateTime() {
    this.selectedDateTime = null;
  }

  setFormFields(data:any){
    this.FormFields=data;
  } 

  getFormFields():any|null{
    return this.FormFields;
  }

  clearFormFields(){
    this.FormFields={};
  }
  
  setDropDowns(data : any){
    this.searchDropDown = data;
  } 

  getDropDowns() : any | null{
    return this.searchDropDown || null;
  }

  clearDropDowns(){
    this.searchDropDown = null;
  }
  
  setPatientData(data:any){
    this.patientData=data;
  } 

  getPatientData():any|null{
    return this.patientData;
  }

  clearPatientData(){
    this.patientData=null;
  }

  setAPTDetails(data:any) {
    this.APTDetails=data;
  }

  getAPTDetails():any|null{
    return this.APTDetails;
  }

  clearAPTDetails(){
    this.APTDetails=null;
  } 
}

const store = new Store();
export default store;
